import React from "react";
import { Link } from "react-router-dom";

const ServicesPreview = ({ t, lang, data, loading }) => {
    return (
        <>
            {loading ? (
                <section className="py-5">
                    <div className="container text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </section>
            ) : (
                data.services.length > 0 && (
                    <section className="py-5">
                        <div className="container">
                            <div className="text-center mb-5" data-aos="zoom-in">
                                <h2 className="fw-bold">
                                    {lang === "en" ? "Our Services" : "خدماتنا"}
                                </h2>
                                <p className="text-muted">
                                    {t("home_services_desc")}
                                </p>
                            </div>

                            <div className="row gy-4 justify-content-center">
                                {data.services.map((s, i) => (
                                    <div className="services-cards col-6 col-lg-4 col-md-6" key={i} data-aos="fade-up">
                                        <div className="card-custom h-100 bg-card shadowP p-4">
                                            <div className="mb-4 text-primary">
                                                <i className={`${s.icon} fs-1`}></i>
                                            </div>

                                            <h4 className="fw-bold mb-3">
                                                {lang === "en" ? s.title_en : s.title_ar}
                                            </h4>

                                            <p className="mb-4">
                                                {lang === "en" ? s.overview_en : s.overview_ar}
                                            </p>

                                            <Link
                                                to={`/service/${s.slug_en}`}
                                                className="fw-bold text-primary"
                                            >
                                                {lang === "en" ? "Read More" : "اقرأ المزيد"}{" "}
                                                <i className="ri-arrow-right-line"></i>
                                            </Link>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="text-center mt-5">
                                <Link to="/services" className="btn btn-primary-custom">
                                    {t("home_why_1")}
                                </Link>
                            </div>
                        </div>
                    </section>
                )
            )}
        </>
    );
};

export default ServicesPreview;